<template>
    <router-view />
</template>

<script>
export default {
    name:'towLayout'
}
</script>